import { ScheduleType } from "@payping/api";
import type { ProductListWordpress } from "@payping/api";
import { DiscountType } from "@payping/api/app/api/invoiceV2Types";
import type { InvoiceCustomerCreateOrUpdateViewModel } from "@payping/api/app/api/invoiceV2Types";
import { SDKDateObject } from "@payping/utils/dateUtils/types";
import type { UploadChangeParam } from "@payping/web-components/components/upload/types";

export interface Product extends ProductListWordpress {
  finalDiscount?: number;
  key?: string;
  price?: number; // calculated total
  discountType?: number;
  discountAmount?: number;
  totalAmount?: number;
  taxtionAmount?: number;
  imageLink?: string;

  /**
   * InvoiceProductCreateViewModel and InvoiceProductDetailViewModel doesn't have intersection for finding whether invoice has tax or not.
   */
  tax?: boolean;
}

export enum InvoiceTypeEnum {
  online = 1,
  cash = 2,
}

export enum CreateStepInvoiceEnum {
  initialSetting = 1,
  scheduling = 2,
  productConnection = 3,
  customerConnection = 4,
}

export interface Customer extends InvoiceCustomerCreateOrUpdateViewModel {
  fullName?: string;
  phoneNumber?: string;
  email?: string;
  key?: string;
  type?: string;
}

export interface InitialSettingType {
  invoiceType: InvoiceTypeEnum;
  isTextReminder?: boolean;
  invoiceName?: string;
  invoiceNumber?: string;
  memo?: string;
  notes?: string;
  termsAndConditions?: string;
  showNotesAfterSuccessPayment?: boolean;
  showTermsAfterSuccessPayment?: boolean;
  conditions?: boolean;
  isTextUser?: boolean;
  terms?: string;
  isCustomerMessage?: boolean;
  customReminderMessage?: string;
}

export interface SchedulingType {
  interval?: number;
  sendDate?: SDKDateObject;
  scheduleType?: ScheduleType;
  dueDate?: SDKDateObject;
  isRepeat?: boolean;
  dueDateAfterHowManyDay?: number;
  count?: number;
}

export interface ProductConnection {
  discountAmount?: string;
  discountType?: DiscountType;
  shipping?: number;
  attachments?: UploadChangeParam;
  sendAttachmentsAfterSuccessPayment?: boolean;
}

interface CustomerValueProps {
  email?: string;
  phone?: string;
  label?: string;
  value?: string;
  key?: string;
  type?: "category";
}

export interface CustomerConnection {
  customers?: CustomerValueProps[];
}

/**
 * status values in form
 * draft => 0
 * send => 1
 * manual => 2
 */
export type SubmitType = "draft" | "send" | "manual";

/**
 * ConfigItemModalProps
 */
export interface ConfigItemModalProps {
  item: Product;

  /**
   * - maximum number of item that user can buy
   * - undefined as unlimited amount of number
   * @default undefined
   */
  maxQuantity?: number;
  onCancel(): void;
  onOk(updateItem: Product): void;
}
